(function () {
  'use strict';

  angular.module('app').component('productAssociatedTaxes', productAssociatedTaxes());

  function productAssociatedTaxes() {
    return {
      bindings: {
        product: '<',
        taxes: '<',
        productType: '@',
        productIsExempt: '<',
        customTaxConfiguration: '<',
        onAssociatedTaxesSaved: '&',
        onAssociatedTaxesCanceled: '&',
      },
      controller: ProductAssociatedTaxesComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/taxes/components/product-associated-taxes/product-associated-taxes.component.html',
    };
  }

  ProductAssociatedTaxesComponent.$inject = [
    'UtilService',
    'ModalWindowConfirmService',
    'SessionService',
    'TaxService',
    'ProductService',
  ];

  function ProductAssociatedTaxesComponent(
    UtilService,
    ModalWindowConfirmService,
    SessionService,
    TaxService,
    ProductService
  ) {
    let vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    // vm.$onInit = function() {
    vm.$onChanges = function () {
      // !important to update sale exoneration
      vm.atvCrEnabled = SessionService.getSelectedAccountCompany().atv_cr_enabled;

      if (vm.customTaxConfiguration) {
        setProductAsociatedTaxesExoneration(vm.taxes);
      } else {
        setProductCategoryAsociatedTaxesExoneration(vm.taxes);
      }

      // Initializers
      vm.validateAssociatedTaxesApplied();
    };

    // public methods
    // -----------------------
    // Validate that at least on tax is selected for both scope types - NOT required for now
    vm.validateAssociatedTaxesApplied = function () {
      vm.invalidAssociatedTaxes = false;
      // vm.invalidAssociatedTaxes = TaxService.validateAssociatedTaxesApplied(vm.taxes);
    };

    vm.applyAssociatedTaxes = function () {
      if (vm.invalidAssociatedTaxes) return;

      // console.log(vm.taxes);

      let confirmAssociatedTaxes = function () {
        let product = setProduct();

        // console.log(vm.productType);
        // console.log(product);
        // return;

        vm.sendingAssociatedTaxes = true;
        TaxService.applyProductAssociatedTaxes(product, vm.productType, true).then(function (
          response
        ) {
          if (response) {
            // Success
            vm.onAssociatedTaxesSaved({ product: response });
          }

          vm.sendingAssociatedTaxes = false;
        });
      };

      let params = {
        title: 'APPLY_CHANGES',
        body: 'APPLY_PRODUCT_ASSOCIATED_TAXES_WARNING',
        mode: 'danger',
        requireConfirmation: true,
      };

      if (vm.productIsExempt) {
        params.body = 'MARK_AS_EXEMPT_PRODUCT_MSG';
      } else {
        if (!vm.customTaxConfiguration) {
          if (!vm.product.custom_tax_configuration) {
            confirmAssociatedTaxes();
            return;
          }

          params.body = 'DELETE_CUSTOM_TAXES_WARNING';
        }
      }

      ModalWindowConfirmService.open(params, confirmAssociatedTaxes);

      // if (vm.customTaxConfiguration) {
      // params.body = 'APPLY_PRODUCT_ASSOCIATED_TAXES_WARNING';
      // } else {
    };

    vm.cancelApplyAssociatedTaxes = function () {
      vm.validateAssociatedTaxesApplied();

      vm.onAssociatedTaxesCanceled();
    };

    vm.openProductTaxExoneration = function (tax, mode) {
      const successCallback = function (exonerationObj) {
        tax.exoneration = exonerationObj;

        if (mode === 'create') {
          let product = setProduct();

          TaxService.applyProductAssociatedTaxes(product, vm.productType).then(function (response) {
            vm.onAssociatedTaxesSaved({ product: response });
          });
        }
      };

      if (!tax.exoneration) {
        tax.exoneration = {};
      }

      ProductService.openProductTaxExoneration(
        tax.exoneration,
        tax,
        vm.productType,
        vm.product.id,
        mode,
        successCallback
      );
    };

    vm.changeProductTaxExonerationStatus = function (tax) {
      ProductService.changeProductTaxExonerationStatus(tax.exoneration, vm.productType);
    };

    vm.deleteProductTaxExoneration = function (tax) {
      let successCallback = function () {
        tax.exoneration = null;
      };

      ProductService.deleteProductTaxExoneration(tax.exoneration, vm.productType, successCallback);
    };

    // private methods
    // -----------------------
    function setProduct() {
      let associatedTaxIds = [];

      if (vm.productIsExempt) {
        vm.customTaxConfiguration = false;
      }

      if (vm.customTaxConfiguration) {
        let associatedPurchaseTaxIds = vm.taxes.purchases
          .filter((purchaseTax) => purchaseTax.checked)
          .map((purchaseTax) => purchaseTax.id);

        let associatedSaleTaxIds = vm.taxes.sales
          .filter((saleTax) => saleTax.checked)
          .map((saleTax) => saleTax.id);

        associatedTaxIds = associatedPurchaseTaxIds.concat(associatedSaleTaxIds);
      }

      return {
        id: vm.product.id,
        associated_tax_ids: associatedTaxIds,
        is_exempt: vm.productIsExempt,
        custom_tax_configuration: vm.customTaxConfiguration,
      };
    }

    // Include the exoneration for the tax
    function setProductAsociatedTaxesExoneration(taxes) {
      taxes.purchases.map((tax) => {
        tax.exoneration = vm.product.exonerations.find(
          (exoneration) => exoneration.tax_id === tax.id
        );
      });

      taxes.sales.map((tax) => {
        tax.exoneration = vm.product.exonerations.find(
          (exoneration) => exoneration.tax_id === tax.id
        );
      });
    }

    // Include the exoneration for the tax
    function setProductCategoryAsociatedTaxesExoneration(taxes) {
      taxes.purchases.map((tax) => {
        tax.product_category_exoneration = vm.product.product_category.exonerations.find(
          (exoneration) => exoneration.tax_id === tax.id
        );
      });

      taxes.sales.map((tax) => {
        tax.product_category_exoneration = vm.product.product_category.exonerations.find(
          (exoneration) => exoneration.tax_id === tax.id
        );
      });
    }
  }
})();
